module.exports = __webpack_public_path__ + "static/media/avar.c32b8ec0.png";